import React, { useRef, useState } from 'react';
import TabsMenuStyled from './bundle.esm2.js';
import TabsMenuItem from './TabsMenuItem/bundle.esm.js';
import MaxWidth from '../MaxWidth/bundle.esm.js';
import useWindowSize from '../../hooks/bundle.esm3.js';
import CONSTANTS from '../../config/bundle.esm.js';
import useIsomorphicLayoutEffect from '../../hooks/bundle.esm.js';

const { BREAKPOINTS } = CONSTANTS;
const TabsMenu = (props) => {
  const { children, className, maxWidth = 480, sidesPadding = 16 } = props;
  const { tabs, maxMobileWidth = BREAKPOINTS.tablet } = props;
  const { width } = useWindowSize();
  const barRef = useRef(null);
  const [barHeight, setBarHeight] = useState(32);
  const isDesktop = width >= maxMobileWidth;
  const getTabs = () => {
    if (Array.isArray(tabs))
      return tabs.filter((tab) => !!tab);
    return [tabs].filter((tab) => !!tab);
  };
  useIsomorphicLayoutEffect(() => {
    if (!barRef.current)
      return;
    const newHeight = barRef.current.getBoundingClientRect().height;
    setBarHeight(newHeight);
  }, []);
  if (isDesktop)
    return /* @__PURE__ */ React.createElement(React.Fragment, null, children);
  return /* @__PURE__ */ React.createElement(TabsMenuStyled, {
    className: `TabsMenu ${className}`,
    barHeight
  }, /* @__PURE__ */ React.createElement("div", {
    className: "TabsMenu__page"
  }, children), /* @__PURE__ */ React.createElement("div", {
    className: "TabsMenu__bar",
    ref: barRef
  }, /* @__PURE__ */ React.createElement(MaxWidth, {
    size: maxWidth,
    minPadding: sidesPadding
  }, /* @__PURE__ */ React.createElement("ul", {
    className: "TabsMenu__tabs"
  }, getTabs().map((child, index) => {
    return /* @__PURE__ */ React.createElement("li", {
      key: index,
      className: "TabsMenu__tabs__item"
    }, child);
  })))));
};
TabsMenu.Item = TabsMenuItem;
TabsMenu.defaultProps = {
  className: ""
};

export { TabsMenu as default };
//# sourceMappingURL=bundle.esm.js.map
